var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusgray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9999 19.6004C12.546 19.6004 14.9878 18.589 16.7881 16.7886C18.5885 14.9883 19.5999 12.5465 19.5999 10.0004C19.5999 7.45431 18.5885 5.01252 16.7881 3.21217C14.9878 1.41182 12.546 0.400391 9.9999 0.400391C7.45382 0.400391 5.01203 1.41182 3.21168 3.21217C1.41133 5.01252 0.399902 7.45431 0.399902 10.0004C0.399902 12.5465 1.41133 14.9883 3.21168 16.7886C5.01203 18.589 7.45382 19.6004 9.9999 19.6004ZM11.1999 6.40039C11.1999 6.08213 11.0735 5.77691 10.8484 5.55186C10.6234 5.32682 10.3182 5.20039 9.9999 5.20039C9.68164 5.20039 9.37642 5.32682 9.15137 5.55186C8.92633 5.77691 8.7999 6.08213 8.7999 6.40039V8.80039H6.3999C6.08164 8.80039 5.77642 8.92682 5.55137 9.15186C5.32633 9.37691 5.1999 9.68213 5.1999 10.0004C5.1999 10.3187 5.32633 10.6239 5.55137 10.8489C5.77642 11.074 6.08164 11.2004 6.3999 11.2004H8.7999V13.6004C8.7999 13.9187 8.92633 14.2239 9.15137 14.4489C9.37642 14.674 9.68164 14.8004 9.9999 14.8004C10.3182 14.8004 10.6234 14.674 10.8484 14.4489C11.0735 14.2239 11.1999 13.9187 11.1999 13.6004V11.2004H13.5999C13.9182 11.2004 14.2234 11.074 14.4484 10.8489C14.6735 10.6239 14.7999 10.3187 14.7999 10.0004C14.7999 9.68213 14.6735 9.37691 14.4484 9.15186C14.2234 8.92682 13.9182 8.80039 13.5999 8.80039H11.1999V6.40039Z",
    fill: "#DFE3E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusgray);
export default __webpack_public_path__ + "static/media/plusgray.93ca469d79dd81fd5cc0a6b7f7787b8c.svg";
export { ForwardRef as ReactComponent };